import { type ReactElement } from 'react';

export function getSectionId(data: SectionListData, key: string): string {
  const i = Object.keys(data).indexOf(key);

  return i >= 0 ? `section-${i + 1}` : '';
}

export interface SectionListData {
  [key: string]: {
    title: string;
    body: ReactElement;
  };
}
